import axios from 'axios';
import { httpBaseClient } from '@systemeio/util';
export const httpClient = axios.create(httpBaseClient.defaults);
httpClient.interceptors.response.use(response => response.data);
